// extracted by mini-css-extract-plugin
export default {"noteCell":"NoteCell_noteCell__3QgCw","noteInput":"NoteCell_noteInput__L6110","savingIndicator":"NoteCell_savingIndicator__wBujp","noteError":"NoteCell_noteError__N7ips"};